<template>
    <div class="cards">
        <img class="card-img" src="../../../assets/clearchoice/provider/hfd/visaCard.png">
        <img class="card-img" src="../../../assets/clearchoice/provider/hfd/masterCard.png"/>
        <img class="card-img" src="../../../assets/clearchoice/provider/hfd/amexCard.png">
        <img class="card-img" src="../../../assets/clearchoice/provider/hfd/discoverCard.png">
    </div>
</template>

<script>
export default {
    name: "HfdDownpaymentSupportedAssociations",
    data() {
        return {
            componentType: "downpaymentSupportedAssociations",
        }
    }}
</script>

<style scoped>
    .card-img {
        width: 40px;
        height: 24px;
    }
</style>
